import {PRODUCTION, STAGING, DEVELOPMENT} from "@irati/utils/constants/environment"
import {PublicClientApplication, LogLevel} from "@azure/msal-browser"
import env from "@irati/utils/env"

const redirectLogoutUrl = () => {
  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    return "https://admin.perkbox.com/welcome/login"
  } else if (env.ENVIRONMENT_NAME === STAGING) {
    return "https://admin.perkbox.net/welcome/login"
  } else if (env.ENVIRONMENT_NAME === DEVELOPMENT) {
    return "https://admin.perkbox.dev/welcome/login"
  }
  return "http://localhost:3000/welcome/login"
}

export const msalConfig = {
  auth: {
    clientId: "2e928ec1-9aab-404d-a8d5-1b177be736ed",
    authority: "https://login.microsoftonline.com/3d374719-8476-4939-b1c5-a64f7c30eb23",
    redirectUri: redirectLogoutUrl()
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  },
  system: {
    pollIntervalMilliseconds: 15,
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        if (level === LogLevel.Error) {
          console.error(message)
        } else if (level === LogLevel.Warning) {
          console.warn(message)
        }
      }
    }
  }
}

export const loginRequest = {
  scopes: ["User.Read"]
}

let instance: PublicClientApplication | null = null

export const msalInstance = () => {
  if (instance) return instance
  instance = new PublicClientApplication(msalConfig)
  return instance
}
